import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/deleteIcon.png'


const _withScopeId = n => (_pushScopeId("data-v-2fbc2dde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-table" }
const _hoisted_2 = { class: "grid-content bg-purple" }
const _hoisted_3 = { class: "grid-content bg-purple" }
const _hoisted_4 = { class: "grid-content bg-purple" }
const _hoisted_5 = { class: "grid-content bg-purple" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("产品相册")
const _hoisted_7 = ["onDrop", "onDragstart"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode("核心描述")
const _hoisted_10 = ["onDrop", "onDragstart"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("应用场景")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_Uploadimg = _resolveComponent("Uploadimg")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "ruleFormRef",
      model: _ctx.ruleForm,
      rules: _ctx.rules,
      "label-width": "120px",
      class: "demo-ruleForm"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "产品名称",
          prop: "title"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.ruleForm.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm.title) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_el_form_item, {
                    label: "产品类型",
                    prop: "productType"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.ruleForm.productType,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ruleForm.productType) = $event)),
                        placeholder: "请选择"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productType, (v, k) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: v.enumName,
                              value: k,
                              key: k
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_form_item, {
                    label: "状态",
                    prop: "status"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.ruleForm.status,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.status) = $event)),
                        placeholder: "请选择"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.status, (v, k) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              label: v.enumName,
                              value: k,
                              key: k
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "封面",
          prop: "coverId"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Uploadimg, {
              image: _ctx.ruleForm.fileUrl,
              onOnSuccess: _ctx.onSuccess
            }, null, 8, ["image", "onOnSuccess"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "描述",
          prop: "description"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.ruleForm.description,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ruleForm.description) = $event)),
              type: "textarea"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_form_item, {
                    label: "app试用下载地址",
                    prop: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleForm.appFileName,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ruleForm.appFileName) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_el_form_item, {
                    label: "pc试用下载地址",
                    prop: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.ruleForm.pcFileName,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.ruleForm.pcFileName) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "试用封面",
          prop: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Uploadimg, {
              image: _ctx.ruleForm.trialUrl,
              onOnSuccess: _ctx.onSamp
            }, null, 8, ["image", "onOnSuccess"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "排序",
          prop: "sortNum"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.ruleForm.sortNum,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.ruleForm.sortNum) = $event)),
              min: 0,
              max: 30
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_divider, { "content-position": "left" }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: " ",
          prop: "albums"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ruleForm.albums, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                onDragover: _cache[7] || (_cache[7] = ($event: any) => (_ctx.allowDrop($event))),
                draggable: "true",
                onDrop: ($event: any) => (_ctx.drop($event,index)),
                onDragstart: ($event: any) => (_ctx.drag($event,index)),
                class: "albums"
              }, [
                _createVNode(_component_el_image, {
                  style: {"width":"100px","height":"100px"},
                  src: item.fileName,
                  fit: "contain"
                }, null, 8, ["src"]),
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "",
                  class: "iconfont ab",
                  style: {"width":"0.2rem","height":"0.2rem"},
                  onClick: ($event: any) => (_ctx.removeList(index))
                }, null, 8, _hoisted_8)
              ], 40, _hoisted_7))
            }), 128)),
            _createVNode(_component_Uploadimg, {
              image: _ctx.ruleForm.fileUrl,
              showIcon: true,
              onOnSuccess: _ctx.albumSuccess
            }, null, 8, ["image", "onOnSuccess"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_divider, { "content-position": "left" }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ruleForm.cores, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            onDragover: _cache[8] || (_cache[8] = ($event: any) => (_ctx.allowDrop($event))),
            draggable: "true",
            onDrop: ($event: any) => (_ctx.hdrop($event,index)),
            onDragstart: ($event: any) => (_ctx.hdrag($event,index)),
            class: "drop"
          }, [
            _createVNode(_component_el_form_item, {
              label: "标题",
              prop: "cores"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: item.title,
                  "onUpdate:modelValue": ($event: any) => ((item.title) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                (index!=0)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _imports_0,
                      alt: "",
                      class: "iconfont re",
                      style: {"width":"0.2rem","height":"0.2rem"},
                      onClick: ($event: any) => (_ctx.removeCore(index))
                    }, null, 8, _hoisted_11))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_form_item, { label: "描述" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: item.description,
                  "onUpdate:modelValue": ($event: any) => ((item.description) = $event),
                  type: "textarea"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_form_item, { label: "封面" }, {
              default: _withCtx(() => [
                _createVNode(_component_Uploadimg, {
                  image: item.fileName,
                  onClick: ($event: any) => (_ctx.getIndex(index)),
                  onOnSuccess: _ctx.coresSuccess
                }, null, 8, ["image", "onClick", "onOnSuccess"])
              ]),
              _: 2
            }, 1024)
          ], 40, _hoisted_10))
        }), 128)),
        _createVNode(_component_el_form_item, { label: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.addCores
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_divider, { "content-position": "left" }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usageScene, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_checkbox, {
                modelValue: item.checked,
                "onUpdate:modelValue": ($event: any) => ((item.checked) = $event),
                label: item.title,
                size: "large",
                key: index
              }, null, 8, ["modelValue", "onUpdate:modelValue", "label"]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef)))
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.router.go(-1)))
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
}